import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Module } from 'src/app/models/administration/module';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { LocalStorageService } from 'brainloper-ui';

@Component({
    selector: 'app-upgrade-plan',
    templateUrl: './upgrade-plan.component.html',
    styleUrls: ['./upgrade-plan.component.scss'],
    standalone: false
})
export class UpgradePlanComponent implements OnInit {

  public moduleName: string = ""
  public modules: Module[] = []

  constructor(
    private router: Router,
    private utils: UtilsServiceService,
    private activeRoute: ActivatedRoute,
    private storage : LocalStorageService
  ) {
    this.modules = this.storage.get<Module[]>('modules') || []
   }

  ngOnInit(): void {
    let queryParams
    this.activeRoute.queryParamMap
    .subscribe(async(params) => {
      queryParams = { ...params };
    this.moduleName = queryParams.params.modulo

    let colorModule = this.modules.find(x => x.name == this.moduleName)
    let element = document.getElementById("noAccessIcon")
    if (element && colorModule) {
      element.setAttribute("style",`color: ${colorModule.color}` )
    }
  })
}
}
